<template>
  <div class="flex flex-col sm:flex-row gap-3 py-3">
    <div class="w-full sm:w-96 brandon-search">
      <ElInput
        size="large"
        v-model="search"
        :prefix-icon="SearchIcon"
        placeholder="Start typing to search categories..."
        clearable
        @keypress.prevent.enter="handleSearch"
      ></ElInput>
    </div>
  </div>
</template>

<script setup>
import { ElInput } from "element-plus";
import { SearchIcon } from "@heroicons/vue/solid";
import { useHomeAvailableContentStore } from "@/stores/home/useHomeAllAvailableContent.store";
import { storeToRefs } from "pinia";
import { useRouter } from "vue-router";

const homeAvailableContentStore = useHomeAvailableContentStore();
const { search } = storeToRefs(homeAvailableContentStore);
const router = useRouter();

const handleSearch = () => {
  router.push({ path: "/search", query: { search: search.value } });
};
</script>

<style scoped>
.brandon-search .el-input__wrapper.is-focus {
  box-shadow: 0 0 0 1px #119381 inset;
}
</style>
